/**
 * DIEUKYDIEU.TV - INTERNATIONALIZATION (i18n) MODULE
 * Supporting: vi (Vietnamese), en (English), zh-TW (Traditional Chinese), zh-CN (Simplified Chinese)
 */

import { state } from './state.js';
import { localesViEn } from './locales/vi-en.js';
import { localesZh } from './locales/zh.js';

export const dict = {
    ...localesViEn,
    ...localesZh
};

export const SUPPORTED_LANGUAGES = [
    { code: 'vi', label: 'Tiếng Việt', short: 'VI' },
    { code: 'en', label: 'English', short: 'EN' },
    { code: 'zh-TW', label: '繁體中文', short: '繁' },
    { code: 'zh-CN', label: '简体中文', short: '简' }
];

export function renderLanguageMenus() {
    if (typeof document === 'undefined') return;
    const menus = [
        document.getElementById('lang-menu'),
        document.getElementById('sidebar-lang-menu')
    ];
    menus.forEach(menu => {
        if (!menu || menu.children.length > 0) return;
        menu.innerHTML = SUPPORTED_LANGUAGES.map(l => `
            <button class="lang-btn${l.code === state.currentLang ? ' active' : ''}" data-lang-val="${l.code}" onclick="selectLang('${l.code}')" role="menuitem">
                <span>${l.label}</span>
            </button>
        `).join('');
    });
}

export function t(key) {
    const lang = state.currentLang;
    return (dict[lang] && dict[lang][key]) || (dict['vi'] && dict['vi'][key]) || key;
}

export function applyLanguage(lang) {
    if (!['vi', 'en', 'zh-TW', 'zh-CN'].includes(lang)) {
        lang = 'vi';
    }
    state.currentLang = lang;
    localStorage.setItem('dieukydieu_lang', lang);
    document.documentElement.lang = (lang === 'zh-TW') ? 'zh-Hant' : (lang === 'zh-CN') ? 'zh-Hans' : lang;

    renderLanguageMenus();

    // 1. Text elements with data-i18n
    document.querySelectorAll('[data-i18n]').forEach(el => {
        const key = el.getAttribute('data-i18n');
        const translated = t(key);
        if (translated) {
            const hasComplexChildren = Array.from(el.children).some(c => c.tagName !== 'BR');
            if (!hasComplexChildren) {
                el.innerHTML = translated;
            } else {
                let textNode = Array.from(el.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.nodeValue.trim().length > 0);
                if (textNode) {
                    textNode.nodeValue = translated;
                } else {
                    el.innerHTML = translated;
                }
            }
        }
    });

    // 2. Placeholder attributes
    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
        const key = el.getAttribute('data-i18n-placeholder');
        el.setAttribute('placeholder', t(key));
    });

    // 3. Title and Aria attributes
    document.querySelectorAll('[data-i18n-title]').forEach(el => {
        const key = el.getAttribute('data-i18n-title');
        el.setAttribute('title', t(key));
    });
    document.querySelectorAll('[data-i18n-aria]').forEach(el => {
        const key = el.getAttribute('data-i18n-aria');
        el.setAttribute('aria-label', t(key));
    });

    // 4. Update language dropdown active classes & checkmark
    document.querySelectorAll('.lang-btn').forEach(btn => {
        const isActive = btn.getAttribute('data-lang-val') === lang;
        btn.classList.toggle('active', isActive);
        btn.querySelectorAll('.lang-check-icon, .material-symbols-rounded').forEach(el => {
            if (el.textContent.trim() === 'check') el.remove();
        });
        if (isActive) {
            const check = document.createElement('span');
            check.className = 'material-symbols-rounded lang-check-icon';
            check.textContent = 'check';
            btn.appendChild(check);
        }
    });

    // 5. Update Navigation aria labels
    document.querySelectorAll('[data-nav-target]').forEach(btn => {
        const target = btn.getAttribute('data-nav-target');
        const labelMap = {
            'home-view': t('nav_home'),
            'category-view': t('nav_explore'),
            'media-view': t('nav_media'),
            'chat-view': t('nav_chat')
        };
        if (labelMap[target]) btn.setAttribute('aria-label', labelMap[target]);
    });

    // 6. Update sidebar language text if present
    const langNames = { vi: 'Tiếng Việt', en: 'English', 'zh-TW': '繁體中文', 'zh-CN': '简体中文' };
    const langCodes = { vi: 'VI', en: 'EN', 'zh-TW': '繁', 'zh-CN': '简' };
    const sidebarLangText = document.getElementById('sidebar-lang-text');
    if (sidebarLangText && langNames[lang]) {
        sidebarLangText.innerText = langNames[lang];
    }
    const sidebarLangCode = document.getElementById('sidebar-lang-code');
    if (sidebarLangCode && langCodes[lang]) {
        sidebarLangCode.innerText = langCodes[lang];
    }

    // 7. Broadcast event or callback for other modules to re-render
    window.dispatchEvent(new CustomEvent('dkd:langchange', { detail: { lang } }));
}

export function toggleLangMenu(e) {
    if (e) e.stopPropagation();
    const menu = document.getElementById('lang-menu');
    if (menu) menu.classList.toggle('show');
}

export function selectLang(langCode) {
    applyLanguage(langCode);
    const menu = document.getElementById('lang-menu');
    if (menu) menu.classList.remove('show');
    const sMenu = document.getElementById('sidebar-lang-menu');
    if (sMenu) sMenu.classList.remove('show');
    const backdrop = document.getElementById('sidebar-lang-backdrop');
    if (backdrop) backdrop.classList.remove('show');
}

// Close language menu when clicking outside
if (typeof document !== 'undefined') {
    document.addEventListener('click', (e) => {
        const menu = document.getElementById('lang-menu');
        if (menu && !menu.contains(e.target) && !e.target.closest('#lang-btn')) {
            menu.classList.remove('show');
        }
        const sMenu = document.getElementById('sidebar-lang-menu');
        if (sMenu && !sMenu.contains(e.target) && !e.target.closest('#sidebar-lang-btn')) {
            sMenu.classList.remove('show');
            const backdrop = document.getElementById('sidebar-lang-backdrop');
            if (backdrop) backdrop.classList.remove('show');
        }
    });
}
